import { useEffect, useRef } from "react"

import Message from "@/components/conversation/message"

export interface MessageData {
  id: string
  text: string
  language: "EN" | "TH"
  timestamp: Date
  audio_url?: string
  translation?: string
  romanization?: string
  explanation?: string
  explanationError?: string
  romanizationError?: string
}

interface MessageListProps {
  messages: MessageData[]
}

export default function MessageList({ messages }: MessageListProps) {
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const bottomRef = useRef<HTMLDivElement>(null)

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" })
    }
  }, [messages])

  if (messages.length === 0) {
    return null
  }

  return (
    <div
      ref={scrollContainerRef}
      className="flex-1 overflow-x-hidden overflow-y-auto px-4 py-6 pb-32"
    >
      {/* Message container with max width */}
      <div className="mx-auto max-w-4xl space-y-4">
        {messages.map((message) => (
          <Message
            key={message.id}
            id={message.id}
            text={message.text}
            language={message.language}
            timestamp={message.timestamp}
            audio_url={message.audio_url}
            translation={message.translation}
            romanization={message.romanization}
            explanation={message.explanation}
            explanationError={message.explanationError}
            romanizationError={message.romanizationError}
          />
        ))}

        {/* Invisible element to scroll to */}
        <div ref={bottomRef} />
      </div>
    </div>
  )
}
